export default {"src":"/_next/static/media/reset-date-filter.1baf0626.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};